import { Injectable } from '@angular/core';

import { BaseHttpService } from './base-http.service';
import { AldermanshipDto } from '@shared/interfaces/dtos/aldermanships';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * @Description
 * Known as "Echevinats"
 */
export class AldermanshipsService extends BaseHttpService {
  protected endPoint: string = 'Global/Echevinats';

  public fetchAldermanships(): Observable<AldermanshipDto[]> {
    return this.http.get<AldermanshipDto[]>(this.buildURL());
  }
}
